/**
 * Helper for ValidateJS equality comparator validator
 * - custom comparator to compare 2 field values,
 * - because single field validation of validateJS cannot compare 2 fields
 * @param {String} value - value to compare
 * @param {String} field - the name of the field to compare against
 * @returns {Boolean}
 */
const equalityComparator = (value, field) => {
  const fieldToCompare = document.querySelector(`[name="${field}"]`)
  return !fieldToCompare ? false : value === fieldToCompare.value
}
export default equalityComparator
